import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';

import { countInsertedRedactions } from '@atlassian/guard-redaction-ui/detection';

import { guardRedactionFlagPluginKey } from './pluginKey.ts';

export type GuardRedactionFlagPluginState = {
	// Running total of redactions remote steps have inserted since this state was created.
	// Cumulative so a consumer that only sees the latest state still knows what it missed.
	insertedTotal: number;
};

// The scan engine redacts by replacing text in remote steps, and the author sees
// those too. Local edits and the initial document load are never redactions.
const isRemoteContentTransaction = (tr: Transaction): boolean =>
	tr.docChanged && Boolean(tr.getMeta('isRemote')) && !tr.getMeta('replaceDocument');

export const createPlugin = (): SafePlugin =>
	new SafePlugin({
		key: guardRedactionFlagPluginKey,
		state: {
			init: (): GuardRedactionFlagPluginState => ({ insertedTotal: 0 }),
			apply: (tr: Transaction, pluginState: GuardRedactionFlagPluginState) => {
				if (!isRemoteContentTransaction(tr)) {
					return pluginState;
				}
				const inserted = countInsertedRedactions(tr);
				if (inserted === 0) {
					return pluginState;
				}
				return { insertedTotal: pluginState.insertedTotal + inserted };
			},
		},
	});
